import type { LucideIcon } from 'lucide-react';
import {
  Bot,
  GitBranch,
  Home,
  LayoutDashboard,
  Network,
  ScanSearch,
  Search,
  Users,
} from 'lucide-react';
import type { UserRole } from '../../types';

export interface NavigationItem {
  path: string;
  icon: LucideIcon;
  label: string;
  roles?: UserRole[];
  matchPaths?: string[];
}

export interface NavigationSection {
  id: string;
  label: string;
  items: NavigationItem[];
}

// «Ажлын орчин» (chart builder / SQL / тайлан) цэснээс НУУГДСАН — оронд нь «Хайлт» ба
// «AI туслах» тус тусдаа. Хайлтын холбоос хайлт ба түүнээс нээгддэг дэлгэрэнгүй
// хуудсуудад идэвхтэй хэвээр (өмнө нь хайлт зөвхөн hub-ийн доторх товчоор нээгддэг тул
// цэснээс харагддаггүй байв).
const SEARCH_PATHS = ['/workspace/search', '/search', '/bidder/', '/tender/', '/organization/', '/governor/'];
const FRAUD_PATHS = ['/fraud', '/corruption-persons'];

export const NAV_SECTIONS: NavigationSection[] = [
  {
    id: 'main',
    label: 'Үндсэн',
    items: [
      { path: '/', icon: Home, label: 'Танилцуулга' },
      { path: '/dashboard', icon: LayoutDashboard, label: 'Хяналтын самбар' },
      { path: '/relations', icon: Network, label: 'Хамаарал' },
    ],
  },
  {
    id: 'analysis',
    label: 'Шинжилгээ',
    items: [
      { path: '/workspace/search', icon: Search, label: 'Хайлт', matchPaths: SEARCH_PATHS },
      { path: '/ai-assistant', icon: Bot, label: 'AI туслах', matchPaths: ['/ai-assistant'] },
      { path: '/fraud', icon: ScanSearch, label: 'Шинжилгээ', matchPaths: FRAUD_PATHS, roles: ['vip', 'admin'] as UserRole[] },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    items: [
      { path: '/pipeline', icon: GitBranch, label: 'Дамжуулалт', roles: ['admin'] },
      { path: '/users', icon: Users, label: 'Хэрэглэгчид', roles: ['admin'] },
    ],
  },
];

export function isNavItemActive(pathname: string, item: NavigationItem): boolean {
  if (item.matchPaths?.some((prefix) => pathname === prefix || pathname.startsWith(prefix))) return true;
  return pathname === item.path;
}

export function filterSectionsByRole(sections: NavigationSection[], role?: UserRole): NavigationSection[] {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => !item.roles || (role && item.roles.includes(role))),
    }))
    .filter((section) => section.items.length > 0);
}
